const TOKEN_KEY = 'prolific_token'
const COMPLETION_KEY = 'prolific_completion_url'

export const setProlificSession = (token: string, completionUrl: string): void => {
  sessionStorage.setItem(TOKEN_KEY, token)
  sessionStorage.setItem(COMPLETION_KEY, completionUrl)
}

export const getProlificToken = (): string | null => sessionStorage.getItem(TOKEN_KEY)

export const getProlificCompletionUrl = (): string | null =>
  sessionStorage.getItem(COMPLETION_KEY)

export const isProlificMode = (): boolean => sessionStorage.getItem(TOKEN_KEY) !== null

export const clearProlificSession = (): void => {
  sessionStorage.removeItem(TOKEN_KEY)
  sessionStorage.removeItem(COMPLETION_KEY)
}
